/* eslint-disable no-alert */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useMount, useUpdateEffect } from 'react-use';
import { useDispatch, useSelector } from 'react-redux';
import {
  AppBar,
  Avatar,
  Box,
  Button,
  Container,
  Divider,
  IconButton,
  Menu,
  Stack,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import EditIcon from '@mui/icons-material/Edit';
import LogoutIcon from '@mui/icons-material/Logout';
import CloseIcon from '@mui/icons-material/Close';
import { checkAuth, setMode, signOut } from '../modules/manager';

import {
  getManagerMode,
  getMobileDevice,
  getUserToken,
  Log,
} from '../common/util';
import Logo from '../components/Logo';
import Footer from '../components/Footer';
// import { initialize } from '../modules/privateManager';
const boxShadow =
  '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)';

const linkData = [
  {
    name: '사이트 이용약관',
    to: '/term#term',
  },
  {
    name: '개인정보 보호',
    to: '/term#privacy',
  },
  {
    name: '위치정보 이용약관',
    to: '/term#location',
  },
];

const robotSubItems = [
  {
    value: '로봇 관리',
    to: '/robot',
  },
  {
    value: '사용자 등록•관리',
    to: '/user',
  },
  {
    value: '봇 관리',
    to: '/bot',
  },
  // {
  //   value: '로봇 Wi-Fi 설정',
  //   to: '/wifi',
  // },
  {
    value: '관리자 로봇 설정',
    to: '/manage',
  },
];
const robotMenu = {
  value: '로봇',
  subItems: robotSubItems,
};
const botSubItems = [
  {
    value: '메시지',
    to: '/bot/message',
  },
  {
    value: '포토',
    to: '/bot/photo',
  },
  {
    value: '음성일기',
    to: '/bot/diary',
  },
  {
    value: '일정',
    to: '/bot/calendar',
  },
  {
    value: '히스토리',
    to: '/bot/history',
  },
];
const botMenu = {
  value: '봇',
  subItems: botSubItems,
};

const tokenException = ['/signin', '/signup', '/term'];

const SiteMenuItem = ({ value, to, subItems }) => {
  const history = useHistory();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const handleToggle = () => {
    if (subItems) {
      setOpen((prevOpen) => !prevOpen);
    } else {
      history.push(to);
    }
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const handleItemClick = (t) => (event) => {
    history.push(t);
    handleClose(event);
  };

  const handleListKeyDown = (event) => {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  };

  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <div>
      <Button
        ref={anchorRef}
        aria-controls={open ? 'composition-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        variant="text"
        size="large"
        onClick={handleToggle}
      >
        {value}
      </Button>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        placement="bottom-start"
        transition
        disablePortal
        style={{ zIndex: 10 }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom-start' ? 'left top' : 'left bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="composition-menu"
                  aria-labelledby="composition-button"
                  onKeyDown={handleListKeyDown}
                >
                  {subItems.map(({ value: v, to: t }) => (
                    <MenuItem key={v} onClick={handleItemClick(t)}>
                      {v}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
};

const SiteWrapper = ({ setColorMode, darkMode, children }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const {
    isLoggedIn: bIn,
    user,
    pending,
    authError: error,
  } = useSelector((state) => state.manager);
  // const isInIframe = window.location !== window.parent.location;
  const [wrapping, setWrapping] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isLoggedIn, setIn] = useState(bIn);
  const [menus, setMenus] = useState([]);
  const [add, setAdd] = useState('none');

  const checkAuthToken = (verify) => {
    const { pathname } = location;
    const token = getUserToken();
    if (token) {
      if (tokenException.includes(pathname)) return history.replace('/');
      return dispatch(checkAuth(token));
    }

    if (!token && !tokenException.includes(pathname) && !verify) {
      return history.replace('/');
    }
    // if (getManagerMode() && pathname !== 'manager') {
    //   dispatch(initialize());
    // }
    return setLoading(false);
  };

  const loadEvent = () => {
    window.removeEventListener('load', loadEvent);
    const { pathname } = location;

    if (pathname.indexOf('/user/verification') < 0) {
      setWrapping(true);
    }
    Log('load check');
    checkAuthToken(pathname.indexOf('/user/verification') === 0);
  };

  const unloadEvent = () => {
    window.removeEventListener('unload', unloadEvent);
    window.addEventListener('load', loadEvent);
  };

  useMount(() => {
    const { pathname } = location;
    window.addEventListener('unload', unloadEvent);
    if (pathname.indexOf('/user/verification') < 0) {
      setWrapping(true);
    }
    Log('mount check');
    checkAuthToken(pathname.indexOf('/user/verification') === 0);
  });

  useEffect(() => {
    const { pathname } = location;
    if (pathname.indexOf('/user/verification') < 0) {
      setWrapping(true);
    }
    Log('location check');
    checkAuthToken(pathname.indexOf('/user/verification') === 0);
  }, [location.pathname]);

  useUpdateEffect(() => {
    if (!user.role) {
      setMenus([]);
    } else {
      const rSubItems = [...robotSubItems];
      if (Number(user.role.substr(0, 1)) < 3) {
        rSubItems.pop();
      }
      setMenus([{ ...robotMenu, subItems: rSubItems }, botMenu]);
    }
  }, [user]);

  useEffect(() => {
    const { pathname } = location;
    if (!wrapping) return;
    setLoading(true);
    if (bIn && !isLoggedIn && pathname === '/signup') {
      Log('회원가입 완료');
      return;
    }
    if (bIn && !isLoggedIn && pathname === '/signin') {
      if (getManagerMode()) {
        history.replace('/manager');
      } else {
        history.replace('/');
      }
      // } else if (
      //   !(
      //     pathException.includes(pathname) ||
      //     pathException.find((path) => pathname.indexOf(path) >= 0)
      //   ) &&
      //   bIn === false
      // ) {
      //   if (getUserToken()) {
      //     alert('세션이 만료되었습니다. 로그인 페이지로 이동합니다.');
      //     dispatch(signOut());
      //   }
      //   history.replace('/signin');
    }
    setLoading(false);
    setIn((prevState) => {
      if (prevState && !bIn) {
        window.location.reload();
      }
      return bIn;
    });
  }, [bIn]);

  useEffect(() => {
    if (error) {
      setIn(false);
      alert(error);
      dispatch(signOut());
      if (location.pathname !== '/') {
        history.replace('/signin');
      } else {
        window.location.reload();
      }
    }
  }, [error]);

  const handleSignIn = () => {
    dispatch(setMode(false));
    history.push('/signin');
  };

  // const handleLogout = () => {
  //   dispatch(signOut());
  // };

  // const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  // const handleOpenNavMenu = (event) => {
  //   setAnchorElNav(event.currentTarget);
  // };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  // const handleCloseNavMenu = () => {
  //   setAnchorElNav(null);
  // };

  const handleUserMenu = (menu) => () => {
    if (menu === 'signout') {
      dispatch(signOut());
      history.replace('/');
    } else if (menu === 'profile') {
      history.push('profile');
    } else if (menu === 'mode') {
      setColorMode();
    }
    setAnchorElUser(null);
  };

  let deferredPrompt;

  useEffect(() => {
    if (!getMobileDevice()) return;
    const addBtn = document.querySelector('.add-button');
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      deferredPrompt = e;
      setAdd('block');
      addBtn.addEventListener('click', () => {
        setAdd('none');
        deferredPrompt.prompt();
        deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            alert('pibo manager console 앱을 추가합니다.');
          } else {
            alert('pibo manager console 앱을 추가하지 않습니다.');
          }
          deferredPrompt = null;
        });
      });
    });
  });

  return (
    <>
      {!wrapping && !loading && children}
      {wrapping && (
        <main
          style={{
            display: 'flex',
            flex: '1 1 auto',
            flexDirection: 'column',
            minHeight: '100vh',
            minWidth: 0,
            position: 'relative',
          }}
        >
          <Box
            sx={{
              width: '100vw',
              backgroundColor: 'secondary.dark',
              display: add,
              position: 'fixed',
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: 999,
            }}
          >
            <Container
              sx={{
                width: '100%',
                color: 'text.primary',
                p: '1em',
                textAlign: 'right',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <IconButton aria-label="close" onClick={() => setAdd('none')}>
                <CloseIcon fontSize="large" />
              </IconButton>
              <Typography>
                <span
                  className="add-button"
                  style={{
                    textDecoration: 'underline',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                  }}
                >
                  여기
                </span>
                를 눌러 바탕화면에 추가하여 편리하게 사용하세요.
              </Typography>
            </Container>
          </Box>
          <AppBar position="static">
            <Container maxWidth="lg">
              <Toolbar disableGutters sx={{ justifyContent: 'space-between' }}>
                <Logo onClick={() => history.push('/')} />
                <Box
                  sx={{
                    flexGrow: 1,
                    display: 'flex',
                    padding: '8px',
                  }}
                >
                  {menus.map(({ value, to, subItems }) => (
                    <SiteMenuItem {...{ value, to, subItems, key: value }} />
                  ))}
                </Box>
                {!(bIn || isLoggedIn) && (
                  <Box
                    sx={{ display: { xs: 'flex' }, gap: '8px', flexGrow: 0 }}
                  >
                    <IconButton
                      sx={{ ml: 1 }}
                      onClick={setColorMode}
                      color="inherit"
                    >
                      {darkMode ? <Brightness7Icon /> : <Brightness4Icon />}
                    </IconButton>
                    {!pending && (
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleSignIn}
                      >
                        로그인
                      </Button>
                    )}
                  </Box>
                )}
                {(bIn || isLoggedIn) && (
                  <Box sx={{ flexGrow: 0 }}>
                    <Tooltip title="사용자 설정 열기">
                      <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                        <Avatar
                          alt={`${user.nickName}의 이미지`}
                          src="/image/img_user.png"
                          sx={{ boxShadow }}
                        />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      sx={{ mt: '45px' }}
                      id="menu-appbar"
                      anchorEl={anchorElUser}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      open={Boolean(anchorElUser)}
                      onClose={handleUserMenu()}
                    >
                      <Box
                        sx={{
                          display: { md: 'flex' },
                          flexDirection: 'row',
                          px: 2,
                          pb: 1,
                        }}
                      >
                        <Stack>
                          <Typography variant="body1">
                            {user.nickName}
                          </Typography>
                          <Typography variant="caption" color="GrayText">
                            {user.institution}
                          </Typography>
                        </Stack>
                      </Box>
                      <Divider />
                      {[
                        { label: '다크모드', name: 'mode' },
                        { label: '정보수정', name: 'profile' },
                        { label: '로그아웃', name: 'signout' },
                      ].map(({ label, name }) => (
                        <MenuItem key={name} onClick={handleUserMenu(name)}>
                          {name === 'mode' && darkMode && (
                            <Brightness7Icon
                              fontSize="small"
                              sx={{ mr: 0.5 }}
                            />
                          )}
                          {name === 'mode' && !darkMode && (
                            <Brightness4Icon
                              fontSize="small"
                              sx={{ mr: 0.5 }}
                            />
                          )}
                          {name === 'profile' && (
                            <EditIcon fontSize="small" sx={{ mr: 0.5 }} />
                          )}
                          {name === 'signout' && (
                            <LogoutIcon fontSize="small" sx={{ mr: 0.5 }} />
                          )}
                          <Typography textAlign="center">{label}</Typography>
                        </MenuItem>
                      ))}
                    </Menu>
                  </Box>
                )}
              </Toolbar>
            </Container>
          </AppBar>
          <div
            style={{
              display: 'flex',
              flex: '1 1 auto',
              flexDirection: 'column',
              position: 'relative',
            }}
          >
            {!pending && children}
          </div>
          <Footer linkData={linkData} />
        </main>
      )}
    </>
  );
};

export default SiteWrapper;
